export const SUPPORT_ADDRESS = 'service.informatique@geschool.fr';
